'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
export const ModalOverlay = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx(motion.div, { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.2 }, ...props, className: cn('keep-modal fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-black bg-opacity-80', className), ref: ref, children: children }));
});
